import {FC} from 'react'
import {StyledPulse} from './style'

type PulseAnimationProps = {duration?: number}

export const PulseAnimation: FC<PulseAnimationProps> = ({duration = 0}) => {
    return <StyledPulse $duration={duration} />
}
